var _path, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12032 34.5465L18.1145 23.5523C18.7746 22.8923 19.1046 22.5622 19.4851 22.4386C19.8199 22.3298 20.1805 22.3298 20.5152 22.4386C20.8957 22.5622 21.2258 22.8923 21.8858 23.5523L32.8067 34.4732M23.3335 25L28.1145 20.219C28.7746 19.5589 29.1046 19.2289 29.4851 19.1053C29.8199 18.9965 30.1805 18.9965 30.5152 19.1053C30.8957 19.2289 31.2258 19.5589 31.8858 20.2189L36.6668 25M16.6668 15C16.6668 16.8409 15.1744 18.3333 13.3335 18.3333C11.4925 18.3333 10.0002 16.8409 10.0002 15C10.0002 13.1591 11.4925 11.6667 13.3335 11.6667C15.1744 11.6667 16.6668 13.1591 16.6668 15ZM11.3335 35H28.6668C31.4671 35 32.8672 35 33.9368 34.455C34.8776 33.9757 35.6425 33.2108 36.1219 32.27C36.6668 31.2004 36.6668 29.8003 36.6668 27V13C36.6668 10.1997 36.6668 8.79961 36.1219 7.73005C35.6425 6.78924 34.8776 6.02433 33.9368 5.54497C32.8672 5 31.4671 5 28.6668 5H11.3335C8.53323 5 7.1331 5 6.06354 5.54497C5.12273 6.02433 4.35783 6.78924 3.87846 7.73005C3.3335 8.79961 3.3335 10.1997 3.3335 13V27C3.3335 29.8003 3.3335 31.2004 3.87846 32.27C4.35783 33.2108 5.12273 33.9757 6.06354 34.455C7.1331 35 8.53323 35 11.3335 35Z",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 34.3654,
    r: 10.865,
    transform: "rotate(45 37 34.3654)",
    fill: "#FF824D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_50867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3769 34.3657H31.6211M36.999 28.9878V39.7436",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_50867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.211,
    height: 15.211,
    fill: "white",
    transform: "translate(36.999 23.6099) rotate(45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPicture);
export default __webpack_public_path__ + "static/media/addPicture.9ac99d63b14b16f824ec488c1eb546ce.svg";
export { ForwardRef as ReactComponent };